<div class="modal-dialog" role="document" >
    <div class="modal-content" [ngClass]="{'error': options.type === SimpleModalType.ERROR, 'success': options.type === SimpleModalType.SUCCESS}">
        <div class="modal-header">
            <h2 class="modal-title">
                <span *ngIf="options.title; else typeDefaultTitle">{{ options.title | translate }}</span>
                <ng-template #typeDefaultTitle [ngSwitch]="options.type">
                    <span *ngSwitchCase="SimpleModalType.SUCCESS">Success!</span>
                    <span *ngSwitchCase="SimpleModalType.ERROR">Oops something went wrong!</span>
                    <span *ngSwitchCase="SimpleModalType.INFO">Information</span>
                    <span *ngSwitchDefault>Are you sure?</span>
                </ng-template>
            </h2>
            <button type="button" class="btn-close" (click)="close(false)" data-bs-dismiss="modal"
                    aria-label="Close"></button>
        </div>
        <div *ngIf="options.content" class="modal-body">
            <p [innerHTML]="options.content | translate: options.textParams"></p>

        </div>
        <div class="modal-footer justify-content-center">
            <ng-container *ngIf="options.type === SimpleModalType.CONFIRM else defaultAction">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="close(false)">Cancel
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="close(true)">Confirm
                </button>
            </ng-container>
            <ng-template #defaultAction>
                <button type="button" class="btn btn-primary" (click)="close(true)">Ok</button>
            </ng-template>
        </div>
    </div>
</div>
